import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router';
import clsx from "clsx";

import {Container, Page} from "./MarketingMessaging.styles";
import {Button} from "@material-ui/core";
import Api from "../../../api";
import {getRoleByTypeNumber} from "utils";
import {usePersistedApi} from "../../../hooks";
import {entities} from "../../../reduxStore";
import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import {HygienistProps, UserAccountProps} from "utils/types";

// @ts-ignore
const Analytics: any = window.TempStars?.Analytics;

interface Market {
    header: string
    description: string
}

interface DataProps {
    hygienist: HygienistProps,
    market: Market
}

const fetchMarket = async (hygienist?: HygienistProps) => {
    return await Api.getMarket({
        postalCode: hygienist?.postalCode,
        state: hygienist?.province,
    });
}

export default function MarketingMessaging() {
    const history = useHistory();
    const [isLoading, setLoading] = useState<boolean>(true)
    const [marketData, setMarketData] = useState<Market>()
    const [market, setMarket] = useState<string>('defaultMarket')
    const [landingMobile, setLandingMobile] = useState<string>('')

    const [
        userAccount,
        hygienistUserLoading,
        hygienistUserError,
        getHygienistUser
    ] = usePersistedApi({
        apiMethod: Api.getUser,
        entityName: entities.user,
        initialValue: {} as UserAccountProps
    })

    const { hygienist } = userAccount;

    useEffect(() => {
        fetchMarket(hygienist).then(market => setMarketData(market))

        const body = document.getElementsByTagName('body')

        if (window.cordova) {
            setLandingMobile('landingMobile')
            body[0].classList.add('bodyWithoutPadding')
        }

        getHygienistUser({})

        return () => {
            if (window.cordova) {
                body[0].classList.remove('bodyWithoutPadding');
            }
        }
    }, []);

    useEffect(() => {
        if (hygienist) {
            if (hygienist?.province === 'IL') {
                setMarket('marketChicago')
            }
            if (hygienist?.province === 'ON') {
                setMarket('marketOntario')
            }
        }
        setLoading(false);
    }, [hygienist, marketData]);

    const goNext = () => {
        if (!hygienist?.type) {
            return;
        }
        Analytics.track('sign-up - acknowledge market terms');
        return history.push({
            pathname: 'SignUp2_Talent'
        }, {
            hygienistId: hygienist?.id,
            country: hygienist?.country,
            role: getRoleByTypeNumber(hygienist?.type),
            province: hygienist?.province,
        })
    }

    let location = hygienist?.city || '';
    if (hygienist?.province === 'IL') {
        location = 'Chicago';
    }
    if (hygienist?.province === 'ON') {
        location = 'Ontario';
    }

    return (
        <Page>
            <Container data-page="marketing-messaging" className={'no-swipeback'}>
                <div id="marketingBackground" className={clsx('background', market)}></div>

                <div className={'navbar landing-navbar unsetBackground'}></div>

                <div className={clsx("landingLogo", landingMobile)}>
                    <img alt={'logo'} className="tempstars-logo-icon centerImg" src={"img/logoWhite.svg"} />
                </div>

                <div className={"marketMessaging"}>
                    <div></div>
                    <div className={"content-block contentBlock"}>
                        <div className="screenTitle">
                            {marketData?.header.replace('{city}', location)}
                        </div>
                        <div className="screenDescription">
                            {marketData?.description}
                        </div>

                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            id="market-button"
                            className="bigButtonInNewStyle"
                            onClick={goNext}
                        >
                            Complete your Profile
                        </Button>
                    </div>
                </div>
            </Container>
            <FixedLoader loading={isLoading || hygienistUserLoading} />
        </Page>
    )
}
